// extracted by mini-css-extract-plugin
module.exports = {"addDocumentPanel":"AddDocumentPopup_AX_addDocumentPanel__FicMK","closeIcon":"AddDocumentPopup_AX_closeIcon__cLY9B","documentNameLink":"AddDocumentPopup_AX_documentNameLink__QRjjI"};